import React from 'react'
import SmartviewSidebar from 'widgets/smartviews/partials/SmartviewSidebar'

export default function SmartviewContainer (props) {
  return (
    <>
      <SmartviewSidebar ghost />
      <SmartviewSidebar>
        {props.children}
      </SmartviewSidebar>
    </>
  )
}
